import type { IProductParams, IProductMetaResponse, IProductResponse, IProductTermResponse,CustomiseOption } from '~/types/product-listing'
import type { SortOption } from '~/types/product-filter';
import type { IProductItem } from '~/types/productItem';
import {displayCustomPrice} from '@/utils/displayPrice';
import { useInsiderSdk } from '~/composables/insiderSdk';
interface SeoDescription {
  normal: string;
  extra: string;
}
export function useProductListing( initialTerms = {}, initialTax = '') {
  const userStore = useUserStore();

  const { productParams,resetParams } = useProductState()
  const runtimeConfig = useRuntimeConfig()
  const { $ajax } = useNuxtApp();
  const isFirstLoad = ref(true);
  const isLoading = ref(false);
  const totalProduct = ref(0);
  const productItems = ref<IProductItem[][]>([])
  const productItemMeta = ref<IProductMetaResponse>();
  const productTerm = ref<IProductTermResponse>();
  const relevantFilters = ref();
  const sortOptions: SortOption[] = ['latest', 'price-low-to-high', 'price-high-to-low', 'bestsellers'];
  const currentTotalProduct = ref<Array<number>>([]);
  const isLoadMore = ref(false);
  const showLoadMore = ref(false);
  const dataMergePlus = ref([]);
  const slBlock = ref(0);
  const currentProductOnPage = ref(0);
  const minMaxPrice = ref({
    min: 0,
    max: 0
  });
  const panigation = ref({
    current: 1,
    total: 0
  });
   const customiseOption = ref<CustomiseOption>({
  material_data: [],
  multiplier_data: {}
});
  resetParams();
  const apiUrl = computed(() => {
    const searchParams = new URLSearchParams()

    Object.entries(productParams.value).forEach(([key, value]) => {
      if ((typeof value === 'string' && value.length > 0) || (typeof value === 'number' && value > 0)) {
        searchParams.append(key, value.toString())
      }
    })

    if( initialTax && initialTax == 'shop' ) {
      searchParams.append('tax', 'shop');

    }

    let url = `${runtimeConfig.public.BASE_URL}data/products?${searchParams.toString()}`;
    // if (runtimeConfig.NODE_ENV === 'development') {
    //   url = `http://127.0.0.1:3005/data/products?${searchParams.toString()}`
    // }

    return url;
  });

  const updateParams = () => {
    const order = ["collection", "category", "material","price_range","gemstone","metal_color","bridal","recipients","gold_type","gift","advanced","occasions", "price", "orderby"];
    const urlParts = [];
    productItems.value = [productItems.value[1]]

    order.forEach(key => {
      if (productParams.value[key] || (productParams.value["default"] === key && initialTerms[key])) {
          if (productParams.value["default"] && productParams.value["default"] === key) {
              // Nếu là default tax, lấy từ initialTerms nếu productParams trống
              const valueToUse = productParams.value[key] || JSON.stringify(initialTerms[key]);
              urlParts.unshift(JSON.parse(valueToUse).join("/"));
              return;
          }
                if (key === 'orderby' && productParams.value[key] === 'latest') {
              return ""; }
          if (productParams.value[key] && productParams.value[key].startsWith("[") && productParams.value[key].endsWith("]")) {
              const value = JSON.parse(productParams.value[key]).join("/");
              if (key === "price") {
                const [minPrice, maxPrice] = productParams.value['price'].split("@");
                  urlParts.push(`price-${(displayCustomPrice(minPrice)+'@'+displayCustomPrice(maxPrice) || "").replace(/[^0-9@]/g, "")}`);
              } else {
                  urlParts.push(value);
              }
          } else if (key === "price") {
            const [minPrice, maxPrice] = productParams.value['price'].split("@");
              urlParts.push(`price-${(displayCustomPrice(minPrice)+'@'+displayCustomPrice(maxPrice) || "").replace(/[^0-9@]/g, "")}`);
          } else if (productParams.value[key]) {
              urlParts.push(productParams.value[key]);
          }
      }
    });

    const arrTax =
    {
      collection:'collection',
      category:'product-category',
      material:'material',
      metal_color:'metal-color',
      gemstone:'gemstone',
      price_range:'product-price-range',
      bridal:'product-bridal',
      recipients:'product-recipients',
      gold_type:'product-gold-type',
      occasions:'product-occasions',
      advanced:'product-advanced',
      gift:'gift',
      shop:'shop'
    }

    // Giữ lại locale prefix từ URL hiện tại
    const currentPath = window.location.pathname;
    const localePrefix = currentPath.startsWith('/ms-my') ? '/ms-my' : '';
    
    const baseUrl = window.location.origin;
    const newUrl = `${baseUrl}${localePrefix}/${arrTax[initialTax]}/${urlParts.filter(Boolean).join("/")}`;
    const url = newUrl.endsWith('/') ? newUrl : `${newUrl}/`;
    window.history.replaceState(null, '', url);
  }

  const renderData = (response: IProductResponse, init: boolean = false) => {

    const { current, total, page, relevant, terms, prices } = response;
    if (!Array.isArray(productItems.value[page.current])) {
      productItems.value[page.current] = [];
    };

    relevantFilters.value = relevant;
    panigation.value = page;
    if(page.current === 1 && !isLoadMore.value) {
      dataMergePlus.value = [];
      productItems.value = [];
    }

    const dataMerge = [...dataMergePlus.value, ... response.data];
    const dataPlus = handleMergeData(dataMerge,current);
    productItems.value[page.current] = [...dataPlus];
    totalProduct.value = total;
    customiseOption.value = response?.option || {
      material_data: [],
      multiplier_data: {}
    };
    productItemMeta.value = {
      current: current,
      total: total,
      page: page,
      relevant: relevant
    }

    productTerm.value = terms;

    relevantFilters.value = relevant;
    isLoading.value = false;
    const previousTotal = currentTotalProduct.value[page.current - 1] || 0;
    currentTotalProduct.value[page.current] = previousTotal+ dataPlus.length - slBlock.value;
    currentProductOnPage.value = currentTotalProduct.value[page.current];
    setLoadMore(page.total);
    if(!showLoadMore.value) {
      currentTotalProduct.value[page.current] = previousTotal + dataMergePlus.value.length + current ;
      dataMergePlus.value = [];
    }
  }

  const setLoadMore = (total: number) => {
    showLoadMore.value = productParams.value.page < total && total > 1;
  }


  const handleLoadMore = () => {
    isLoadMore.value = true;
    const nextPage = Number(productParams.value.page) + 1;
    productParams.value.page = nextPage;
    fetchProducts(productParams.value.page, true);
    localStorage.setItem('curentPageList', nextPage);
    localStorage.setItem('curentPage', nextPage);
    // console.log(panigation.value.current,'panigation.value.currentpanigation.value.currentpanigation.value.current')
    setLoadMore(nextPage);
  }

  const fetchProducts = async (pageCurrent: number, loadMore: boolean) => {
    isLoading.value = true;
    if (loadMore) isLoadMore.value = true;
    else{ productParams.value.page = 1; isLoadMore.value = false;}
    try {
       const response = await $ajax.get(apiUrl.value, {
              headers: {
                'X-API-Key': userStore.csrf,
                'X-API-Site': ( userStore.user && userStore.user.role === 'administrator' ) ? 'b13c4834515d124fe30c48fb65c5643f' : 'b13c4834515d124fe30c48fb65c5644f',
              }
            }) as IProductResponse;

      // price_axios
      const {prices } = response;
      const min = prices.min;
      const max = prices.max;
      // if(max > minMaxPrice.value.max){
        minMaxPrice.value = {
          min: min,
          max: max
        }
      // }
      renderData(response);
      // console.log
    } catch (error) {
      isLoading.value = false;
    }
  }



  const handleSortBy = (sort: SortOption) => {
    if( ! sortOptions.includes(sort) ) {
      return;
    }

    if( productParams.value.orderby === sort) {
      return;
    }

    const currentPath = window.location.pathname;
    if (sort === "latest") {
      if (currentPath.includes(productParams.value.orderby)) {
          window.history.replaceState(
              null,
              '',
              currentPath.replace(`/${productParams.value.orderby}`, '')
          );
      }
  }

    if (currentPath.includes(productParams.value.orderby)) {
      window.history.replaceState(null, '', window.location.pathname.replace(productParams.value.orderby, sort));
    }else {
      window.history.replaceState(null, '', window.location.pathname + sort + '/');
    }

    productParams.value.orderby = sort;
    productParams.value.page = 1;
    productItems.value = [];
    // totalProduct.value = 0;
    fetchProducts(productParams.value.page, false);
  }

  const clearProductParams = () => {
    productParams.value = {};
  }

  const getInitData = async () => {
    productParams.value.page = 1;
    panigation.value.current = 1;
    isLoadMore.value = false;
    if( initialTax && initialTax == 'shop' && typeof initialTerms[initialTax] !== 'undefined' ) {
      const terms = initialTerms[initialTax];
      const orderBy = terms.find(term =>
        sortOptions.includes(term as SortOption)
      );
      if( typeof orderBy !== 'undefined' ) {
        productParams.value.orderby = orderBy;
      }
    }


    try {
      const { data, error } = await useAsyncData(
        'fetchInitData',
        async () => {
          return $ajax.get(apiUrl.value, {
            headers: {
              'X-API-Key': userStore.csrf,
              'X-API-Server': userStore.csrf_server,
              'X-API-Site': ( userStore.user && userStore.user.role === 'administrator' ) ? 'b13c4834515d124fe30c48fb65c5643f' : 'b13c4834515d124fe30c48fb65c5644f',
            }
          });
        }
      );

      if(error.value) {
        fetchProducts(1, false);
      }else {
        // price_init
        const response = data.value as IProductResponse;
         const {prices,names_terms} = response;
        minMaxPrice.value = {
          min: prices.min,
          max: prices.max
        }
        renderData(response, true);

        // insider sdk
        const wooStore = useWooStore();
        const {
        trackInsiderSdkEvent
        } = useInsiderSdk();

        trackInsiderSdkEvent(
          'insider_sdk_category',
          '',
          'MYR',
          { insider_category_value: names_terms }
        );
        // end inside sdk

      }



    } catch (err: any) {
      // console.log('err.response', err);
    }
  }
  const handleMergeData = (data: any = [],current?:number) => {
    if (!Array.isArray(data)) {
      return [];
    }
    const slSize1 = data.filter((item: any) => item.size === '1').length;
    const slSize2 = data.filter((item: any) => item.size === '2').length;
    const slSize3 = data.filter((item: any) => item.size === '3').length;

    const slItemFalse = data.length - (slSize1 + slSize2 + slSize3);
    slBlock.value =   slSize1+slSize2+slSize3;
    const toalSl = slItemFalse + (1 * slSize1 + 2 * slSize2 + 4 * slSize3);

    let dataPlus: any[] = [];
    let itemPlus: any[] = [];
    if (current && current <= 40 && panigation.value.current === panigation.value.total) {
      return data
    }

    if( dataMergePlus.value.length > 0 ) {
      dataMergePlus.value = [];
    }

    if (toalSl % 4 !== 0) {
      itemPlus = data.slice(data.length - (toalSl % 4), data.length);
      dataPlus = [...data.slice(0, data.length - (toalSl % 4))];
      dataMergePlus.value = itemPlus;
    } else {
      // console.log('toalSl', toalSl);
      dataPlus = data
      itemPlus = [];
      dataMergePlus.value = itemPlus;
    }
    return dataPlus;
  };

  const handleBackAndScroll = async () => {
    const pageCurrentUrl = window.location.href;
    if (process.client) {
      const currentPage = parseInt(localStorage.getItem('curentPage') || '1');
      const curentPageList = parseInt(localStorage.getItem('curentPageList') || '1');
      const scrollPosition = parseInt(localStorage.getItem('scroll') || '0');
      const refPageUrl = localStorage.getItem('pageUrl');

      if (refPageUrl !== pageCurrentUrl) {
        localStorage.setItem('curentPage', 1);
        localStorage.setItem('scroll', 0);
        localStorage.setItem('pageUrl', '');
        return
      }
      try {
        // if (curentPageList > 1) {
        //   const fetchPromises = [];
        //   for (let i = 2; i <= currentPage; i++) {
        //     productParams.value.page = i;
        //     fetchPromises.push(fetchProducts(productParams.value.page, true));
        //   }
        //   await Promise.all(fetchPromises);
        // } else {
        //   return
        // }

        // pt list product to single back to list product
        if (curentPageList > 1) {
          const pages = Array.from({ length: currentPage - 1 }, (_, i) => i + 2);
          await pages.reduce(async (prevPromise, page) => {
            await prevPromise;
            productParams.value.page = page;
            return fetchProducts(productParams.value.page, true);
          }, Promise.resolve());
        }else{
          return
        }

      } catch (error) {
        // console.error(error);
        isLoading.value = false;
      } finally {
        isLoading.value = false;
        window.scrollTo(0, scrollPosition);
        localStorage.setItem('curentPage', '1');
        localStorage.setItem('curentPageList', '1');
        localStorage.setItem('scroll', '0');
      }
    }
  };

  return {
    isFirstLoad,
    isLoading,
    showLoadMore,
    isLoadMore,
    currentTotalProduct,
    totalProduct,
    productParams,
    productItems,
    productItemMeta,
    productTerm,
    relevantFilters,
    minMaxPrice,
    currentProductOnPage,
    updateParams,
    getInitData,
    fetchProducts,
    handleSortBy,
    handleLoadMore,
    handleBackAndScroll,
    clearProductParams,
    customiseOption
  }
}